import {
    GETALLGATEWAYMAPPINGLIST_SUCCESS,
    GETALLGATEWAYMAPPINGLIST_FAILED,
    RESET_GETALLGATEWAYMAPPINGLIST,
    LOADING_GETALLGATEWAYMAPPINGLIST,
    NETWORK_ERROR_GETALLGATEWAYMAPPINGLIST,
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetAllGatewayMappingList = () => {
    return { type: RESET_GETALLGATEWAYMAPPINGLIST };
};

const allGatewayMappingList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETALLGATEWAYMAPPINGLIST });
    await adminServices
        .post("getAllGatewayMappingList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.responseCode) {
                case "1":
                    dispatch(allGatewayMappingListsuccess(res.data));
                    break;
                default:
                    dispatch(allGatewayMappingListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_GETALLGATEWAYMAPPINGLIST, payload: err });
        });
};
function allGatewayMappingListsuccess(data) {
    return {
        type: GETALLGATEWAYMAPPINGLIST_SUCCESS,
        payload: data,
    };
}
function allGatewayMappingListFailed(data) {
    return {
        type: GETALLGATEWAYMAPPINGLIST_FAILED,
        payload: data,
    };
}

export { resetAllGatewayMappingList, allGatewayMappingList };
